import { getCompoundEntityRef } from '@backstage/catalog-model';
import DocsIcon from '@material-ui/icons/Description';
import { useRouteRef } from '@backstage/core-plugin-api';
import { useEntity, entityRouteRef } from '@backstage/plugin-catalog-react';
import { EntityIconLinkBlueprint } from '@backstage/plugin-catalog-react/alpha';
import {
  TECHDOCS_ANNOTATION,
  TECHDOCS_EXTERNAL_ANNOTATION,
} from '@backstage/plugin-techdocs-common';

function useEntityTechDocsTabIconLinkProps() {
  const { entity } = useEntity();
  const entityRoute = useRouteRef(entityRouteRef);
  const hasTechDocs =
    Boolean(entity.metadata.annotations?.[TECHDOCS_ANNOTATION]) ||
    Boolean(entity.metadata.annotations?.[TECHDOCS_EXTERNAL_ANNOTATION]);

  return {
    label: 'View TechDocs',
    disabled: !hasTechDocs || !entityRoute,
    icon: <DocsIcon />,
    href: entityRoute
      ? `${entityRoute(getCompoundEntityRef(entity))}/docs`
      : undefined,
  };
}

export const entityTechDocsIconLink = EntityIconLinkBlueprint.make({
  name: 'embedded-techdocs',
  params: {
    useProps: useEntityTechDocsTabIconLinkProps,
  },
});
